let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("btCqR"), load("107zu"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));